import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'ark-confirm-billing-addition',
  templateUrl: './confirm-billing-addition.component.html',
  styleUrls: ['./confirm-billing-addition.component.scss']
})
export class ConfirmBillingAdditionComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmBillingAdditionComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {}

  close(flag = false) {
    this.dialogRef.close(flag);
  }
}
